import { useEffect } from 'react';
import { GrowthBookProvider } from '@growthbook/growthbook-react';
import growthbook from '@/lib/growthbook';
import { userStore } from '@/store/user/store';
import { useResolvedProductSlug } from '@/hooks/useResolvedProductSlug';
import { isGoogleOTP } from '@/utils/googleOTPData';

/**
 * Determines if a user should be excluded from experiments.
 * Add additional exclusion criteria using || as needed:
 * return isGoogleOTP() || isInternalUser() || isBetaTester();
 */
const isExcludedFromExperiments = (): boolean => {
  return isGoogleOTP();
};

export default function GrowthBookWrapper({ children }: { children: React.ReactNode }) {
  const { user } = userStore();
  const resolvedSlug = useResolvedProductSlug();

  useEffect(() => {
    // Dynamically build attributes object
    const newAttributes: Record<string, unknown> = {
      ...growthbook.getAttributes(),
      anonymous_id: growthbook.getAttributes()['id'],
      excluded_from_experiments: isExcludedFromExperiments(),
      ...(user.id && {
        user_id: user.id.toString(),
        registrationState: user.registration_state,
      }),
      ...(resolvedSlug && { productSlug: resolvedSlug }),
    };

    growthbook.setAttributes(newAttributes);
  }, [user, resolvedSlug]);

  return <GrowthBookProvider growthbook={growthbook}>{children}</GrowthBookProvider>;
}
